export default "https://cdn-static.gokick.com/assets/9175df2ab050434674d4a27e4dae3ab0ebb22d80/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";